import { createCommunityAuthContext } from './createCommunityAuthContext';

const { Provider: QuintaAuthProvider, useAuth: useQuintaAuth } = createCommunityAuthContext({
  community: 'quinta',
});

export { QuintaAuthProvider, useQuintaAuth };
